import $ from 'jquery'
import debounce from 'lodash/debounce'
import { isValidEmail } from './helpers'
import { pluralize } from './helpers'

const debug = require('debug')('pm:suppressions')

function validateEmailList() {
  debug('Validate email upload')

  const $count = $('.js-suppression-count')
  const $error = $('.js-suppression-error')
  const $button = $('.js-add-suppression-button')
  const $row = $(this).parents('.c-form-row')
  const lines = $(this)
    .val()
    .split(/\n/g)
    .filter(line => line.length > 0) // Match all lines
  const lineCount = lines.length
  const validEmailCount = lines.filter(line => isValidEmail(line)).length
  const invalidEmailCount = lines.filter(line => !isValidEmail(line)).length

  // Deal with counts
  if (lineCount === 0 || $(this).val() === '') {
    $count.hide()
  } else {
    $count.show()
    $count.html([
      `${validEmailCount > 0 ? pluralize(validEmailCount, 'recipient') : ''}`,
      `<span class="u-pad-left-xs u-link-danger">${
        invalidEmailCount > 0 ? pluralize(invalidEmailCount, 'error') : ''
      }</span>`,
    ])
  }

  if (lineCount > 50) {
    // Show error
    $error.show()
    $row.addClass('error')
    $count.addClass('has-error')
    $button.prop('disabled', true)
  } else {
    // hide errors
    $error.hide()
    $row.removeClass('error')
    $count.removeClass('has-error')
    $button.prop('disabled', false)
  }
}

$(document).on(
  'keyup paste',
  '.js-suppression-input',
  debounce(validateEmailList, 400)
)
